export const STATE = 'STATE';
export const MODELS = 'MODELS';
export const ERROR = 'ERROR';
export const OFFERS_FULL = 'OFFERS_FULL';
export const OFFERS_FULL_COUNT = 'OFFERS_FULL_COUNT';
export const CMS_DISCLAIMER = 'CMS_DISCLAIMER';
export const FINANCE_FILTER_TERM = 'FINANCE_FILTER_TERM';
export const FINANCE_FILTER_ADVANCE = 'FINANCE_FILTER_ADVANCE';
export const FINANCE_FILTER_MILEAGE = 'FINANCE_FILTER_MILEAGE';
export const FINANCE_FILTER_MAINT = 'FINANCE_FILTER_MAINT';
export const VEHICLE = 'VEHICLE';
export const SME_DESCRIPTIONS = 'SME_DESCRIPTIONS';
export const SEARCH_RESULTS = 'SEARCH_RESULTS';
export const SEARCH_BUSY = 'SEARCH_BUSY';
export const SEARCH_RESULTS_COUNT = 'SEARCH_RESULTS_COUNT';
export const SEARCH_RESULTS_PER_PAGE = 'SEARCH_RESULTS_PER_PAGE';
export const SEARCH_RESULTS_PAGE = 'SEARCH_RESULTS_PAGE';
export const FILTER_DATA_BODY = 'FILTER_DATA_BODY';
export const FILTER_DATA_MANUFACTURER = 'FILTER_DATA_MANUFACTURER';
export const FILTER_DATA_MODEL = 'FILTER_DATA_MODEL';
export const FILTER_MANUFACTURER = 'FILTER_MANUFACTURER';
export const FILTER_FUEL_TYPE = 'FILTER_FUEL_TYPE';
export const FILTER_CO2 = 'FILTER_CO2';
export const FILTER_RENTAL = 'FILTER_RENTAL';
export const FILTER_BODY = 'FILTER_BODY';
export const FILTER_MODEL = 'FILTER_MODEL';
export const FILTER_TYPE = 'FILTER_TYPE';
export const FILTER_ORDER = 'FILTER_ORDER';
export const FILTER_DATA_FUEL_TYPES = 'FILTER_DATA_FUEL_TYPES';
export const RESET = 'RESET';
export const PRESET_MANUFACTURER = 'PRESET_MANUFACTURER';
export const MANUFACTURER_LIST = 'MANUFACTURER_LIST';

